import { Modal } from "react-bootstrap";
import backIcon from "../../../../images/arrow-left-solid.png";
import placeholderImage from "../../../../images/placeholder-image.png"

export default function ItemVoucherProductListPage(props) {
    let voucherMenuNumber = `voucherMenu${props.loyaltyMember.ItemVoucherProductListPage.SelectedGroup.VoucherMenuNumber}`;
    let groupDetails = props.loyaltyMember.VoucherDetails.OriginalData[voucherMenuNumber][0];
    let productsInGroup = groupDetails.products;

    // Map Products
    let productList = productsInGroup.map((item) => {

        let energyCount;
        if (item.energyCount !== 0 && item.energyCount !== "0" && item.energyCount !== "" && item.energyCount !== null) {
            energyCount = <div className="mt-2">
                            <span className="badge bg-secondary bg-opacity-50">{item.energyCount}kJ</span>
                        </div>
        } else {
            energyCount = <></>
        }

        return (
            <div className="col-12 g-3 g-md-4 d-grid" key={item.productID}>
                <button type="button" className="btn btn-light p-0 m-0 border d-flex flex-column align-items-start overflow-hidden" 
                    data-productid={item.productID} 
                    onClick={props.handleSelectProductItemVoucherProductList}
                >
                <div className="px-1 py-2 rounded-3 row m-0 w-100">
                    <div className="col-9 col-md-8 text-start d-flex flex-column justify-content-between" style={{wordBreak: "break-word"}}>
                        <div>
                            <b>{item.productDisplayName}</b>
                            {item.productDescription && <><br /><span>{item.productDescription}</span></>}
                        </div>
                        {energyCount}
                    </div>
                        <div className="col-3 col-md-4 position-relative" style={{height: "max-content"}}>
                            <img src={item.productImageURL ? item.productImageURL : placeholderImage} className="rounded-3 float-end my-2 w-100 shadow-sm" style={{objectFit: "cover", objectPosition: "center center", aspectRatio: "1/1", maxWidth: "300px", minWidth: "70px"}} alt="Product"></img>
                        </div>
                    </div>
                </button>
            </div>
        )
    })

    return (
        <>
            <div className="modal-header justify-content-start">
                <button type="button" className="btn btn-light rounded-pill" onClick={props.handleBackItemVoucherProductList} disabled={props.loyaltyMember.ItemVoucherProductListPage.GeneralError.ButtonsDisabled}>
                    <img src={backIcon} alt="Back" title="Back" style={{width: "20px"}}></img>
                </button>
                <h1 className="modal-title fs-5 text-break">&emsp;Select Voucher Details</h1>
                <button type="button" className="btn-close" aria-label="Close" onClick={props.handleClickCloseLoyaltyModal}></button>
            </div>
            <Modal.Body className="pt-0">
                <div className="row">
                    {productList}
                </div>
            </Modal.Body>
        </>
    )
}